import React, { useCallback, useState } from 'react';

const YouTubeIcon = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {isHovered ? (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="25" height="25" rx="6" fill="#FEFEFE" />
          <g clipPath="url(#clip0_1848_100)">
            <path
              d="M21.5015 7.95728C21.3955 7.55838 21.1866 7.19432 20.8957 6.90154C20.6048 6.60875 20.242 6.39751 19.8438 6.28895C18.3779 5.89478 12.5186 5.89478 12.5186 5.89478C12.5186 5.89478 6.65918 5.89478 5.19327 6.28895C4.79506 6.39751 4.43235 6.60875 4.14144 6.90154C3.85052 7.19432 3.64161 7.55838 3.5356 7.95728C3.14355 9.42958 3.14355 12.4999 3.14355 12.4999C3.14355 12.4999 3.14355 15.5702 3.5356 17.0425C3.64161 17.4414 3.85052 17.8055 4.14144 18.0982C4.43235 18.391 4.79506 18.6023 5.19327 18.7108C6.65918 19.105 12.5186 19.105 12.5186 19.105C12.5186 19.105 18.3779 19.105 19.8438 18.7108C20.242 18.6023 20.6048 18.391 20.8957 18.0982C21.1866 17.8055 21.3955 17.4414 21.5015 17.0425C21.8936 15.5702 21.8936 12.4999 21.8936 12.4999C21.8936 12.4999 21.8936 9.42958 21.5015 7.95728Z"
              fill="#FF0302"
            />
            <path d="M10.6006 15.2879V9.71191L15.5012 12.4999L10.6006 15.2879Z" fill="#FEFEFE" />
          </g>
          <defs>
            <clipPath id="clip0_1848_100">
              <rect width="18.75" height="18.75" fill="white" transform="translate(3.125 3.125)" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg width="25" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.771484" y="0.0571289" width="25" height="25" rx="6" fill="#FEFEFE" />
          <g clipPath="url(#clip0_1851_632)">
            <path
              d="M22.3602 8.76702C22.3602 8.76702 22.1779 7.48021 21.6166 6.91517C20.9057 6.17152 20.111 6.16787 19.7465 6.12413C17.1364 5.93457 13.2176 5.93457 13.2176 5.93457H13.2103C13.2103 5.93457 9.29156 5.93457 6.68148 6.12413C6.31694 6.16787 5.52225 6.17152 4.8114 6.91517C4.25002 7.48021 4.0714 8.76702 4.0714 8.76702C4.0714 8.76702 3.88184 10.2798 3.88184 11.789V13.2034C3.88184 14.7126 4.06775 16.2254 4.06775 16.2254C4.06775 16.2254 4.25002 17.5123 4.80776 18.0773C5.51861 18.8209 6.45182 18.7954 6.86739 18.8756C8.36199 19.0178 13.214 19.0615 13.214 19.0615C13.214 19.0615 17.1364 19.0543 19.7465 18.8683C20.111 18.8246 20.9057 18.8209 21.6166 18.0773C22.1779 17.5123 22.3602 16.2254 22.3602 16.2254C22.3602 16.2254 22.5461 14.7163 22.5461 13.2034V11.789C22.5461 10.2798 22.3602 8.76702 22.3602 8.76702ZM11.2856 14.9204V9.67472L16.3271 12.3067L11.2856 14.9204Z"
              fill="#2B2A29"
            />
          </g>
          <defs>
            <clipPath id="clip0_1851_632">
              <rect width="18.6643" height="18.6643" fill="white" transform="translate(3.88184 3.16772)" />
            </clipPath>
          </defs>
        </svg>
      )}
    </div>
  );
};

export default YouTubeIcon;